import React, { useEffect, useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BuyNowCart from "../common/BuyNowCart";
import {
  setAddVariantToCart,
  setUpdateQuantityInCart,
  setRemoveLineItemInCart,
  getProductDetails,
} from "../../util/utils.js";
import Link from "next/link";
import { formatImageUrl } from "../../../helper/helper";

const options: any = [{ value: "United Kingdom", label: "United Kingdom" }];

const ProductDetailsFirstFold = (props: any) => {
  const { data, countryCode, checkout, setCheckout } = props;
  const [openModal, setOpenModal]: any = React.useState(false);
  const [showAddToCart, setShowAddToCart] = useState(false);
  const [stock, setStock] = useState(false);
  const [currentPrice, setCurrentPrice]: any = useState();

  useEffect(() => {
    if (countryCode === "en-GB" || countryCode === "en-US") {
      setShowAddToCart(true);
    }
    if (data) {
      let shopifyProductID: any = data?.shopifyproduct_id;
      let productID: any = `gid://shopify/Product/${shopifyProductID}`;
      getProductDetails(productID, countryCode)?.then((productDetails) => {
        console.log("shopifyProductID", productDetails);
        if (productDetails) {
          const productPrice: any =
            productDetails?.variants?.[0]?.price?.amount;

          setStock(productDetails?.availableForSale);
          setCurrentPrice(productPrice);
        }
      });
    }
  }, [data]);

  const addToCart = (data: any) => {
    const productId = `gid://shopify/ProductVariant/${data.shopify_id}`;
    const lineItemsToAdd = [
      {
        merchandiseId: productId,
        quantity: 1,
      },
    ];

    if (countryCode) {
      setAddVariantToCart(lineItemsToAdd, countryCode).then((res) => {
        setCheckout({
          ...res,
        });
        toggleCartSidebar();
      });
    }
  };

  const updateQuantityInCart = (lineItemId: any, quantity: any) => {
    const lineItemsToUpdate = [
      { id: lineItemId, quantity: parseInt(quantity, 10) },
    ];
    setUpdateQuantityInCart(lineItemsToUpdate, countryCode).then((res) => {
      setCheckout({
        ...res,
      });
    });
  };

  const removeLineItemInCart = (lineItemId: any) => {
    setRemoveLineItemInCart(lineItemId, countryCode).then((res) => {
      setCheckout({
        ...res,
      });
    });
  };

  const toggleCartSidebar = () => {
    setOpenModal(!openModal);
  };

  const buyButton = (props: any) => {
    return (
      <>
        {stock &&
        showAddToCart &&
        data?.shopifyproduct_id &&
        data?.shopify_id ? (
          <button className="buy-now-btn" onClick={() => addToCart(data)}>
            BUY NOW
          </button>
        ) : !stock ? (
          <button className="buy-now-btn btn_disabled">
            {props?.not_available_btn_text
              ? props?.not_available_btn_text
              : "NOT AVAILABLE"}
          </button>
        ) : // <button className="buy-now-btn btn_disabled">NOT AVAILABLE</button>
        null}
      </>
    );
  };
  let bgImage: any;

  if (typeof window !== "undefined") {
    bgImage = formatImageUrl(
      window.innerWidth <= 760
        ? "/new-product-details/octave-logo-mobile.svg"
        : "/new-product-details/octave-logo.svg",
    );
  }

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="new-product-details-inner-wrapper">
      <div className="new-product-details-firstfold">
        <BuyNowCart
          countryCode={countryCode}
          openModal={openModal}
          toggleCartSidebar={toggleCartSidebar}
          checkout={checkout}
          updateQuantityInCart={updateQuantityInCart}
          removeLineItemInCart={removeLineItemInCart}
        />
        <Container>
          <Row>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={6}
              className="inline-padding-for-mobile-only"
            >
              <div className="imageBox">
                <div className="mainImageWrapper">
                  <img
                    src={data?.images?.data[activeIndex]?.attributes?.url}
                    alt="Octave Whisky"
                  />
                </div>
              </div>
              <div className="thumbnailWrapper">
                {data?.images?.data?.map((img: any, index: any) => {
                  // if (index === activeIndex) return null;
                  return (
                    <button
                      key={`${img?.attributes?.url}-${index}`}
                      className={`thumb ${
                        index === activeIndex ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(index)}
                    >
                      <img src={img?.attributes?.url} alt="thumbnail" />
                    </button>
                  );
                })}
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <div className="right-outerwrapper">
                <div className="right-panel">
                  <img src={bgImage} alt="" />
                  <h2 className="product-title">{data?.name}</h2>
                  <h3 className="product-subtitle">{data?.age}</h3>

                  <p className="product-description">{data?.description}</p>
                  <Link href={"#details"}>
                    {/* <span className="read-more">Read More</span> */}
                  </Link>

                  <div className="tasting-notes">
                    <h3 className="tasting-title">Tasting notes</h3>

                    <div className="tasting-grid">
                      <div className="note-column">
                        <h4>Before Octivation</h4>
                        <p>{data?.before_octivation_content}</p>
                      </div>
                      <div className="note-column">
                        <h4>After Octivation</h4>
                        <p>{data?.after_octivation_content}</p>
                      </div>
                    </div>
                  </div>

                  <div className="price-section">
                    <div className="price-section-inner">
                      {currentPrice && !isNaN(Number(currentPrice)) && (
                        <p className="price">
                          {countryCode === "en-GB" ? "£" : "$"}
                          {(Number(currentPrice) * 1.2).toFixed(2)}
                        </p>
                      )}

                      {currentPrice && (
                        <p className="price-vat">
                          {countryCode === "en-GB" ? "£" : "$"}
                          {Number(currentPrice).toFixed(2)} EX VAT
                        </p>
                      )}
                    </div>
                    <p className="shipping-text">
                      Shipping calculated at checkout.
                    </p>
                  </div>

                  {/* <button className="buy-now-btn">BUY NOW</button> */}
                  {buyButton(data)}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default ProductDetailsFirstFold;
